import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import NestedDashboardOptionsEditor from './nestedDashboardOptionsEditor.vue';
export default {
  name: 'ActionParametersEditDialog',
  components: {
    NestedDashboardOptionsEditor
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    action: {
      type: Object,
      required: true
    },
    parameterDefinitions: {
      type: Array,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      temporaryActionParameters: {}
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    ...mapState('dashboards', ['dashboards']),
    dashboard() {
      return this.dashboards[this.dashboardId];
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    visibleParameterDefinitions() {
      return this.parameterDefinitions.filter(this.evaluateParameterIfCondition);
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.temporaryActionParameters = {};
      }
    },
    parameterDefinitions: {
      handler(newDefinitions) {
        const clone = cloneDeep(this.temporaryActionParameters);
        newDefinitions.forEach(parameter => {
          if (clone[parameter.key] !== undefined) {
            return;
          }
          if (this.action.parameters[parameter.key] !== undefined) {
            clone[parameter.key] = this.action.parameters[parameter.key];
          }
          if (clone[parameter.key] === undefined) {
            clone[parameter.key] = parameter.default;
          }
        });
        Object.keys(clone).forEach(key => {
          if (!newDefinitions.some(p => p.key === key)) {
            delete clone[key];
          }
        });
        this.temporaryActionParameters = clone;
      }
    }
  },
  methods: {
    parseInputValue(type, value) {
      if (type === 'number') {
        return Number(value);
      }
      return value;
    },
    updateActionParameter(key, type, value) {
      const clone = cloneDeep(this.temporaryActionParameters);
      clone[key] = this.parseInputValue(type, value);
      this.temporaryActionParameters = clone;
    },
    saveActionParameters() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const combinedParameters = {
        ...this.action.parameters,
        ...this.temporaryActionParameters
      };
      this.$emit('update:parameters', combinedParameters);
    },
    evaluateParameterIfCondition(parameter) {
      if (!parameter.if) {
        return true;
      }
      let condition = parameter.if;
      let invert = false;
      if (condition.startsWith('!')) {
        invert = true;
        condition = condition.substring(1);
      }
      const value = get(this.temporaryActionParameters, condition);
      return invert ? !value : !!value;
    }
  }
};